import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage } from '../../../utils/Errors'
import { IInfo } from '../../slices/infoSlice'
import { getUrl } from '../../../api/api'

export const fetchInfo = createAsyncThunk<IInfo, void, ThunkConfig<string>>(
    'infoSlice/fetchInfo',
    async (_args, thunkAPI) => {
        const {
            extra: { api },
            rejectWithValue,
        } = thunkAPI

        try {
            const { data } = await api.get<IInfo>(getUrl(`/info`))

            return data
        } catch (e) {
            alertErrorMessage(e)
            return rejectWithValue('Failed to fetch info')
        }
    }
)
